<template>
  <div class="cookie dark-theme" v-cloak  :class="{ 'hide-cookie': hideCookie }">
    <div class="container">
      <div class="cookie-header">
        <div class="cookie--title">
          <span class="mdi--cookie"></span>
          <span>Cookie Policy</span>
        </div>
        <span class="cookie--close"  @click="closeDialog">
            <md-icon>close</md-icon>
          </span>
      </div>
      <div class="cookie-info">
        <div class="cookie--content">
          We use 🍪(Cookies) to provide our services and for analytics and marketing.
          This includes cookies from third party social media websites and advertising cookies that may analyze your use of this site.<br><br>
          To find out more about our use of cookies, please see our <a href="/privacy-policy">Privacy Policy</a>. By continuing to browse our website, you agree to our use of cookies.
        </div>
        <div class="cookie--actions">
          <md-button class="md-button md-raised md-primary bn-cookie-alert-btn" @click="acceptCookies">{{ buttonTextAccept }}</md-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CookieMessage",
  props: {
    buttonTextAccept: {
      type: String,
      default: "Accept",
    },
  },
  data() {
    return {
      hideCookie: true,
    }
  },
  methods: {
    acceptCookies() {
      this.$emit('close'); // Emit custom event
      // document.cookie = "gdpr_opt_in_capturing=yes; path=/"; // Set gdpr_opt_in_capturing in cookie
      localStorage.setItem('gdpr_opt_in_capturing', 'yes');
    },
    closeDialog() {
      this.$emit('close'); // Emit custom event
    },
  },
};
</script>

<style lang="scss" scoped>
 @import "../styles/variables.scss";
  .cookie {
    z-index: 99999;
    bottom: 0;
    position:fixed;

    @include breakpoint(desktop) {
      width: 25vw !important;
      max-width:420px;
      left:  10px !important;
      margin-bottom: 10px !important;
    }
    @include breakpoint(mobileSmall) {
      width: 100%;
      left: 0;
      margin-bottom:0;
    }
  }

  .cookie .container {
    padding:10px;
  }

  a {
    color: rgb(172, 192, 255) !important;
    text-decoration: underline;
    transition: all .25s;
    font-size: 0.80rem;
    &:hover {
      text-decoration: none;
    }
  }

  .cookie-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .cookie--title {
    font-size: 1.2rem;
    margin-bottom: 0.75rem;
    margin-top: 0.75rem;
    display: flex;
    gap: 0.5rem;
    align-items: center;
  }

  .cookie--content {
    font-size: 0.85rem;
    line-height: 1.25rem;
  }

  .cookie--content .action-blurb,
  .cookie--actions .action-blurb{
    display: block;
    margin-top: 1rem;
    font-size: 0.80rem;
    color: rgba(135, 135, 135, 1);
  }

  .cookie--actions {
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    @include breakpoint(mobileSmall) {
      flex-direction: column;
      align-items: center;
      margin-top: 1rem;
      text-align: center;
    }
    gap: 1rem;
    padding-left:10px;
    padding-right:10px;
  }

  .mdi--cookie {
    display: inline-block;
    width: 1em;
    height: 1em;
    --svg: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23000' d='M12 3a9 9 0 0 0-9 9a9 9 0 0 0 9 9a9 9 0 0 0 9-9c0-.5-.04-1-.13-1.5C20.6 10 20 10 20 10h-2V9c0-1-1-1-1-1h-2V7c0-1-1-1-1-1h-1V4c0-1-1-1-1-1M9.5 6A1.5 1.5 0 0 1 11 7.5A1.5 1.5 0 0 1 9.5 9A1.5 1.5 0 0 1 8 7.5A1.5 1.5 0 0 1 9.5 6m-3 4A1.5 1.5 0 0 1 8 11.5A1.5 1.5 0 0 1 6.5 13A1.5 1.5 0 0 1 5 11.5A1.5 1.5 0 0 1 6.5 10m5 1a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5m5 2a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5M11 16a1.5 1.5 0 0 1 1.5 1.5A1.5 1.5 0 0 1 11 19a1.5 1.5 0 0 1-1.5-1.5A1.5 1.5 0 0 1 11 16'/%3E%3C/svg%3E");
    background-color: currentColor;
    -webkit-mask-image: var(--svg);
    mask-image: var(--svg);
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-size: 100% 100%;
    mask-size: 100% 100%;
  }

  /* Dark theme */
  .cookie.dark-theme {
    background-color: rgba(48, 48, 48, 1);
    color: #fff;

    .bn-cookie-alert-btn {
      background-color: var(--md-theme-default-accent) !important;
      color: #fff !important;
      @include breakpoint(desktop) {
        width: inherit;
        font-weight: bold;
      }
      @include breakpoint(mobileSmall) {
        width: 100%;
        padding: 1rem;
        font-size: 1rem;
        font-weight: bold;
        margin-top: 1rem;
      }
    }

    .cookie--close {

      padding: 0.5rem;
      &:hover {
        cursor: pointer;
      }
      i {
        color: #fff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// apps/www.bravenet.com/src/components/cookie-message.vue